import React, { useEffect, useState } from 'react';
import './get_started.scss';
import arrowDown from '../../../assets/image/arrow_down_dark.svg';
import arrowUp from '../../../assets/image/arrow_up_dark.svg';
import ExpandedTab from './component/expanded';
import { getGettingStarted } from '../../../services/dashboard';

export default function GetStartedScreen({ setTotalPercentage }) {
	const [gettingStarted, setGettingStarted] = useState(null);
	const [openIndex, setOpenIndex] = useState(null);

	async function handleFetchGettingStartedData() {
		try {
			const { getting_started } = await getGettingStarted();
			setGettingStarted(getting_started);
			setTotalPercentage(getting_started.overall_percentage);
		} catch (error) {
			console.error('Error fetching onboarding data:', error);
		}
	}

	useEffect(() => {
		handleFetchGettingStartedData();
	}, []);

	if (!gettingStarted) {
		return (
			<div
				className="d-flex justify-content-center align-items-center"
				style={{ height: '80vh', overflow: 'hidden' }}
			>
				<span
					className="Page_loader"
					role="status"
					aria-hidden="true"
				></span>
			</div>
		);
	}

	return (
		<div
			className="setup-container"
			style={{ overflow: 'hidden', minHeight: '80vh' }}
		>
			{gettingStarted.modules.map((module, index) => {
				const total = module.total_submodules || 0;
				const completed = module.total_completed_submodules || 0;
				const progress = total > 0 ? (completed / total) * 100 : 0;

				return (
					<div
						key={module.id}
						className="setup-section"
					>
						<div
							className="setup-header"
							onClick={() => setOpenIndex(openIndex === index ? null : index)}
						>
							<div className="header-title text-start d-flex align-items-center pt-4">
								<p>{module.name} Setup</p>
							</div>

							<div className="d-flex justify-content-center align-items-center gap-3 progress-bar-container">
								<div className="progress-bar">
									<div
										className="progress-fill"
										style={{ width: `${progress}%` }}
									></div>
								</div>
								<span className="progress-text">
									{completed} of {total} tasks completed
								</span>
							</div>

							<div
								className="get-started-dropdown-container"
								style={{ width: '15%' }}
							>
								<img
									src={openIndex === index ? arrowUp : arrowDown}
									style={{ cursor: 'pointer' }}
									className="dropdown-icon"
									alt=""
								/>
							</div>
						</div>

						{/* Expanded Section */}
						{openIndex === index && module.submodules.length > 0 && (
							<ExpandedTab
								tasksList={module.submodules.map((s) => ({
									name: s.name,
									done: s.is_completed,
									desc: s.onboarding_description || '',
									action: s.url,
									key: s.key,
									button_title: s.url_text || `Create ${s.name}`,
								}))}
								handleFetchGettingStartedData={handleFetchGettingStartedData}
								setOpenIndex={setOpenIndex}
								openIndex={openIndex}
								index={index}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
}
